var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.75 7C10.75 6.30964 11.3096 5.75 12 5.75C12.6903 5.75 13.25 6.30964 13.25 7V13.25C13.25 13.9404 12.6903 14.5 12 14.5C11.3096 14.5 10.75 13.9404 10.75 13.25V7ZM10.75 17C10.75 16.3096 11.3096 15.75 12 15.75C12.6903 15.75 13.25 16.3096 13.25 17C13.25 17.6904 12.6903 18.25 12 18.25C11.3096 18.25 10.75 17.6904 10.75 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleRed);
export default __webpack_public_path__ + "static/media/exclamationCircleRed.30dd7bfeb1934d2c33771dacd6e237b7.svg";
export { ForwardRef as ReactComponent };